import { Dialog } from "@headlessui/react";
import { useTranslation } from "next-i18next";
import { useForm, FormProvider } from "react-hook-form";

import { StandardDialog } from "@/features/common/components/layout/StandardDialog";
import { TipsPaymentView } from "@/features/tips/components/tipsPaymentDialog/TipsPaymentView";
import { TipsSummaryView } from "@/features/tips/components/tipsPaymentDialog/TipsSummaryView";

export const TipsConfirmDialog = ({ open, onClose }) => {
  const { t } = useTranslation("tips");
  const methods = useForm();

  const onSubmit = (data) => {
    // console.log(data)
  };
  return (
    <StandardDialog
      open={open}
      onClose={onClose}
      className="max-w-3xl"
      showCloseButton={true}
    >
      <div className="p-8">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Dialog.Title
              as="h3"
              className="text-2xl font-normal text-gray-900 mb-4"
            >
              {t("tips:tipsConfirmDialog.title")}
            </Dialog.Title>
            {/*  payment amount */}
            <TipsSummaryView />

            {/*  payment method */}
            <TipsPaymentView onClose={onClose} />
          </form>
        </FormProvider>
      </div>
    </StandardDialog>
  );
};
